/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useMemo } from 'react';
import { Field } from 'redux-form';
import { OpenCSSProperties } from 'aphrodite';
import { InputContainer } from '../InputContainer';
import { fieldPropsMap, complexInputMap } from '../config';
import { InputConfig, ComplexInputConfig, BaseInputConfig } from '../types';
import { required as defaultRequired } from '../validators';
import { compact } from '@utils/lodash';

export namespace TaskInput {
  export interface Props extends React.HTMLAttributes<HTMLInputElement> {
    config: InputConfig;
    customStyle?: OpenCSSProperties;
  }
}

export const TaskInput: React.FC<TaskInput.Props> = ({ config, customStyle = undefined, ...htmlProps }) => {
  // TODO This logic should really be cleaned up; the memoization should only happen on basic task inputs
  const ComplexInput = complexInputMap[config.type];
  const fieldProps = fieldPropsMap[(config as BaseInputConfig).type] || ComplexInput;
  const { requiredValidator = defaultRequired, validate } = fieldProps || {};
  const validators = useMemo(() => compact([config.required && requiredValidator, validate]), []);

  if (ComplexInput) {
    // ComplexInput are for any input that is more than a single Field
    // this config should always be ComplexInputConfig because ComplexInput is only defined when
    // config type is one of the complex input type
    return <ComplexInput required={config.required} config={config as ComplexInputConfig} />;
  }

  return (
    <Field
      {...htmlProps}
      {...fieldProps}
      name={config.id}
      component={InputContainer}
      config={config}
      required={config.required}
      validate={validators}
      customStyle={customStyle}
    />
  );
};
